var exports = {
  "i": "xaee3c4fa--8b6bc0--wrapper",
};

module.exports = exports;
